import type { IEnvConfig } from '../types';
import { unionThemeFormat } from './helpers';

export const uxlabConfig: IEnvConfig = {
  name: 'uxlab',
  survey: {
    callbackURL: 'https://uxlab.imur.qq.com/api/v1/callback/survey',
  },
  desktop: {
    namespace: 'uxlab.imur',
    versionLabel: 'iMUR',
    hasTestEnv: true,
  },
  cos: {
    bucket: 'uxlab-files-1253502009',
    region: 'ap-guangzhou',
  },
  group: {
    groupBy: 'union',
    groupIdField: 'union_id',
    themeFormat: unionThemeFormat,
  },
  ui: {
    bodyClass: '',
    cardPTeamClass: false,
    subtitleDuration: 3,
    dateFormat: 'yyyy-MM-dd HH:mm:ss',
    defaultPlayerMode: 0,
    loginIconType: 'uxlab',
    sloganStyle: 'uxlab',
  },
  features: {
    enableBeacon: true,
    enableAegis: true,
    showTopText: true,
    showUsageReason: true,
    showRoundSelect: false,
    showOperationGuide: true,
    showRemoteControl: true,
    canEditProductName: false,
    canEditProductOwner: false,
    canEditRound: false,
    showSessionCount: false,
    showRegisterHint: true,
    showLoginFooter: false,
    showThemeInClassify: true,
    showGroupVideoLayout: true,
    showDualShareLinks: true,
    showDeviceEquipment: false,
    showUsageNotice: true,
    showMobileTipsBar: true,
    isAggregatedByUnionId: true,
    showProjectAssociation: true,
    usePusherScheme1080p: true,
    showThemeRequiredForMultipleSessions: true,
    showMultiPusher: false,
    showPlayerInfoDialog: false, // 国内版预订时不需要「设备和玩家信息」弹窗
    showMaterialTest: true,
    showCloudCE: true,
    showAsrLangSwitch: true,
    showCaptionTranslation: true,
    showBorrowableDevice: true,
    showSmartSummary: true,
  },
  text: {
    appTitle: '腾讯互娱体验室系统',
    adminContact: 'luceyyang(杨琪丹)',
    adminContactLink: 'wxwork://message.com/?username=',
    adminEmail: '',
    accountLabel: '账号',
    copySuccessMessage: '已将链接复制至剪贴板',
    inviteSuccessMessage: '座谈会信息已复制到剪切板',
    shareSuccessMessage: '分享信息已复制到剪切板',
    registerHint: '开始注册腾讯互娱体验室系统!',
    waitApprovalHint: '请等待管理员审核',
    checkEmailHint: '请注意查收邮件~',
    nonTencentUserHint: '非腾讯用户需使用邮箱账号注册，并通过管理员审核方可观看。',
    contactAdminHint: '如您有非腾讯用户需要观看，请提前联系',
    labContactTip: '如当前设备数量不满足需求，可联系v_sszou',
    sloganDesc: '',
  },
};
